import React from 'react';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { N300 } from '@atlaskit/theme/colors';
import { helpLegalLinks } from '@css-xp/ppc-consent-hub';
import { headingSizes } from '@atlaskit/theme/typography';

const InProductHelpFooterContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  fontSize: `${headingSizes.h300.size}px`,
  textAlign: 'center',
  height: '25px',
  marginBottom: '60px',
});

const StyledFooterLink = styled.a({
  color: `${token('color.text.subtlest', N300)}`,
  fontWeight: 500,
});

export const InProductHelpFooter = () => {
  return (
    <InProductHelpFooterContainer id="in-product-help-footer">
      <StyledFooterLink href={helpLegalLinks.termsOfUseUrl} target="_blank" rel="noreferrer">
        Terms of use
      </StyledFooterLink>
      <StyledFooterLink href={helpLegalLinks.privacyPolicyUrl} target="_blank" rel="noreferrer">
        Privacy policy
      </StyledFooterLink>
    </InProductHelpFooterContainer>
  );
};
